var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card__content"},[(_vm.entreprise.member)?_c('div',{staticClass:"card__member"},[_vm._v("Membre")]):_vm._e(),_c('h3',{staticClass:"card__title"},[(!_vm.entreprise.member)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.entreprise.title)}}):_c('router-link',{attrs:{"to":{
          name: 'entreprise',
          params: {
            slug: _vm.entreprise.slug,
          },
        }}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.entreprise.title)}})])],1),_c('p',{staticClass:"card__section"},[_vm._v(" "+_vm._s(_vm.entreprise.member_activite ? _vm.entreprise.member_activite : _vm.entreprise.section)+" ")]),_c('p',{staticClass:"card__adresse"},[_vm._v(_vm._s(_vm.entreprise.adresse))])]),(_vm.entreprise.member_logo)?_c('router-link',{staticClass:"card__image",attrs:{"to":{
      name: 'entreprise',
      params: {
        slug: _vm.entreprise.slug,
      },
    }}},[_c('img',{attrs:{"src":_vm.entreprise.member_logo,"alt":_vm.entreprise.title}})]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }